<template>
  <div class="page" v-if="showPage">
    <navigation type="second-level" :sticky="true" @click="detention" :customClickEvent="true">
      我要提现
    </navigation>
    <div class="swiper-card">
      <temporary-limit class="temporary-limit" :temporaryLimit="bizAdjustAmount" :maxLimit="limitMaxCanLoanAmount" v-if="bizAdjustAmount && limitMaxCanLoanAmount && activeIndex===1"></temporary-limit>
      <van-swipe :show-indicators="false" :loop="false" :width="swiperWidth" @change="change" class="swiper-container" indicator-color="white">
        <van-swipe-item class="item" >
          <div class="card-item card-item1">
            <div class="title">
              <img src="./image/icon_quanyi@2x.png">
              额度UP卡｜提现通道
            </div>
            <div class="info">
              <span>可提现额度 (元)</span>
              <b>{{ form.applyAmt | amount }}</b>
              <p>被拒7个工作日内退款</p>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item class="item item2">
          <div class="card-item card-item2">
            <div class="title">
              天美贷｜提现通道
            </div>
            <div class="info">
              <div class="amount-container">
                <span>当前可用额度 (元) </span>
                <div class="money" @click="openKeyboard">
                  <template v-if="activeIndex===1">{{ form.applyAmt | amount }}</template>
                  <template v-else>0</template>
                </div>
              </div>
              <div class="max-withdraw" @click="maxWithdraw">最大提现</div>
            </div>

            <div class="money-range ">
              <div class="min-money">
                最低(元) {{ productMinLimit | amount }}
              </div>
              <div class="max-money">
                最高(元)  {{ maxAmt | amount }}
              </div>
            </div>

          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 表单 -->
    <form class="form card-panel">
      <div class="form-item underline-un-focus">
        <nd-choose
          label="怎么花"
          :valueKey="['key', 'description']"
          :data="dictionary.loanPurpose"
          v-model="form.purpose"
        >
        </nd-choose>
      </div>

      <div class="form-item underline-un-focus">
        <nd-choose
          label="分几期"
          :data="termList"
          :placeholder="placeholder"
          v-model="form.applyTerm"
          :beforeClick="beforeSelectTerm"
        >
        </nd-choose>
      </div>
    </form>

    <div class="use-tips" v-if="activeIndex===0"><img src="./image/img_tixian_tie@2x.png" alt=""></div>
    <div class="tips" v-if="!canLoanApply">
      {{ canotLoanReason }}
    </div>
    <section class="bottom">
      <nd-button class="confirm" @click="next" :disabled="isDisabled">{{ canLoanApply ? '下一步：预览提现详情' : '暂不可提现' }}</nd-button>
      <section class="read-protocol">
        <span>综合年化利率以实际每笔订单放款审核为准</span>
      </section>
    </section>
    <nd-dialog
      v-model="noRouteDialog"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-template-content">
        <div class="title">今日额度已满</div>
        <div class="content">
          <p>很抱歉，今日资方额度已满，您可明日发起重试或申请退款</p>
        </div>

        <nd-button class="btn" @click="noRouteDialog=false">我再看看</nd-button>

        <div class="giveup-btn" @click="$router.push('/vip/index?findTarget=UPC_M&noExit=Y')">去退款</div>
      </div>
    </nd-dialog>
 


    <nd-dialog
      v-model="tipsVisible"
      class="tips-dialog"
      :footer="false"
      :closeBtn="true"
      @close="tipsVisible=false"
    >
      <div class="tips-content">
        <div class="header">
          温馨提示
        </div>
        <p class="body">
          尊敬的用户，我们发现您的最高可提现金额<span
            class="highlight"
          >{{ productMaxLimit | amount }}元</span>
        </p>
        <p class="body">
          您提现成功后，需要结清借款后才可以再次发起提现哦，请您妥善评估提现金额以备不时之需。
        </p>
        <nd-button class="footer" @click="confirm">
          立即提现{{ productMaxLimit | amount }}元
        </nd-button>
        <p class="cancel" @click="tipsVisible = false">已知悉，暂不需要这么多金额</p>
      </div>
    </nd-dialog>

    <!--自定义键盘-->
    <nd-keyboard ref="keyboard" :stepSize="lendingAmountStep" :start-money="startMoney" :visible="keyboardVisible" @changeResult="getKeyboardInput" @step="stepHandler"></nd-keyboard>

    <!-- 二次挽留 -->
    <backPopup ref="backPopup" backType="ALL"></backPopup>
   
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import { mapState, mapActions, mapMutations } from 'vuex'
import ServicePass from './components/service-pass.vue'
import { getKey, removeKey } from '@/assets/utils'
const WITHDRAW_PASSCARD_FORM_KEY = 'withdrawForm'
export default {
  name: 'upCard',
  components: {
    ServicePass,
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    'temporary-limit': () => import('./components/temporary-limit.vue'),
    backPopup: () => import('./components/back-popup')
  },
  data () {
    return {
      swiperWidth: document.body.clientWidth - 80,
      noRouteDialog: false,
      tipsVisible: false,
      productSubList: [],
      amtProductList: [],
      fundCode: '',
      canLoanCode: '',
      canLoanApply: true,
      canotLoanReason: '',
      orderNo: this.$route.query.partnerOrderNumber,
      isExternalChannel: ['API-XHQB'].includes(getKey('channel')),
      form: {
        applyAmt: '',
        applyTerm: '',
        purpose: '',
        bankCardNo: ''
      },
      productRemaindLimit: 0,
      productMaxLimit: 5000,
      productMinLimit: 5000,
      lendingAmountStep: 500,
      keyboardVisible: false,
      activeIndex: 0,
      showPage: false,

      bizAdjustAmount: 0, // 业务侧调额
      limitMaxCanLoanAmount: 0 // 限时最高可提额度
    }
  },
  computed: {
    ...mapState({
      dictionary: state => state.dictionary
    }),
    maxAmt () {
      let _amt = 0
      if (this.limitMaxCanLoanAmount) {
        _amt = this.productMaxLimit > this.limitMaxCanLoanAmount ? this.limitMaxCanLoanAmount : this.productMaxLimit
      } else {
        _amt = this.productMaxLimit
      }
      return _amt
    },
    // 键盘起始值
    startMoney () {
      return Number(this.form.applyAmt)
    },

    termList () {
      if (!this.productSubList || this.productSubList.length === 0) {
        return []
      }
      return this.amtProductList.map((item) => {
        return {
          name: item + '个月',
          value: item
        }
      })
    },
    placeholder () {
      return this.termList.length > 0 ? '请选择' : '暂无支持分期'
    },
    isDisabled () {
      return !(
        this.form.applyAmt &&
        this.form.applyTerm &&
        this.form.purpose &&
        this.canLoanApply
      )
    }
  },
  async created () {
    await this.fetchDictionary()
    this.init(true)
    this.$sensors.track('Element_Exposure', { caseId: 'UP卡片' })
    this.$bus.$emit('ready')
  },
  beforeDestroy () {
    clearTimeout(window.timmer)
  },
  watch: {
    'form.applyAmt' (val) {
      if (val) {
        this.getAmountProduct(val)
      }
    }
  },
  methods: {
    ...mapMutations('withdraw', ['setWithdrawForm']),
    ...mapActions('withdraw', [
      'getLoanParameterX',
      'amtProductX',
      'getFundRouteX',
      'canLoanX',
      'judgeMissingX',
      'getLoanTrialX',
      'getMaxLimit',
      'getLoanDetentionPopType'
    ]),
    ...mapActions('vip', ['buyVipResult']),
    ...mapActions(['fetchDictionaryX']),
    async init (upCard = false) {
      await this.getLoanParameter(upCard ? 'UP_CARD' : null)
      // this.getAmountProduct(this.form.applyAmt)
      this.canLoan()
      this.showPage = true
    },
    confirm () {
      this.form.applyAmt = this.productMaxLimit
      this.tipsVisible = false
    },
    change (i) {
      this.form.applyAmt = 0
      this.form.applyTerm = 0
      this.activeIndex = i
      this.$sensors.track('Element_Exposure', { caseId: i === 0 ? 'UP卡片' : '额度卡片' })
      !i ? this.init(true) : this.init()
    },
    // 最大提现
    maxWithdraw () {
      this.form.applyAmt = this.maxAmt
      this.$message(`已修改提现金额为${this.form.applyAmt}`)
    },

    // 键盘返回值
    async getKeyboardInput (value) {
      if (value) {
        if (value === 0) {
          this.closeKeyboard()
        } else if (value > 0 && value < this.productMinLimit) {
          this.form.applyAmt = this.productMinLimit
          this.$message(
            `您当前最小提现金额为${this.productMinLimit}元`
          )
        } else if (
          value >= this.productMinLimit &&
          value <= this.productMaxLimit
        ) {
          if (value % this.lendingAmountStep === 0) {
            this.form.applyAmt = value
          } else {
            this.form.applyAmt =
              Math.ceil(value / this.lendingAmountStep) *
              this.lendingAmountStep
            this.$message(
              `每笔提现金额必须为${this.lendingAmountStep}的整数倍`
            )
          }
        } else if (value > this.productMaxLimit) {
          this.form.applyAmt = this.productMaxLimit
          this.$message(
            `您当前最大提现金额为${this.productMaxLimit}元`
          )
        }
        if (this.productMaxLimit > value) {
          let { success, data } = await this.getMaxLimit({ 'loanPlatform': 'TMD' }) // 最大提现金额判断
          if (success && data) {
            this.tipsVisible = true
          }
        }
      }
      this.closeKeyboard()
      // 最大提现金额判断
    },
    // 修改提现金额
    detensionForChangeAmount () {
      this.continueApply()
    },

    // 关闭键盘
    closeKeyboard () {
      this.$report({
        id: 10091,
        args: {
          visible: 0,
          target: this.stepCount
        }
      })
      this.stepCount = 0
      this.keyboardVisible = false
    },

    // 点击步长
    stepHandler () {
      this.stepCount++
    },

    // 打开键盘
    openKeyboard () {
      this.$refs.keyboard.init(this.startMoney)
      this.keyboardVisible = true
    },
    async fetchDictionary () {
      await this.fetchDictionaryX()
    },
    // 查询借款参数
    async getLoanParameter (riskTagProcess) {
      const params = {
        loanPlatform: 'TMD',
        virtualLimit: 'Y'
      }
      if (riskTagProcess) {
        params.riskTagProcess = riskTagProcess
      }
      const response = await this.getLoanParameterX(params)
      if (response.success && response.data) {
        this.bizAdjustAmount = response.data.bizAdjustAmount
        this.limitMaxCanLoanAmount = response.data.limitMaxCanLoanAmount
        // 初始化range区间及间隔
        if (this.isExternalChannel) {
          // 初始化range区间及间隔
          this.productRemaindLimit = response.data.productMaxLimit
          this.productMaxLimit = Math.floor(response.data.productMaxLimit / 100) * 100
          this.productMinLimit = response.data.productMinLimit
          this.lendingAmountStep = response.data.lendingAmountStep
            ? response.data.lendingAmountStep
            : 500
          // 额度默认取最大
          this.form.applyAmt = this.form.applyAmt || this.productMaxLimit
          // 产品列表
          this.productSubList = response.data.productSubList
        } else {
          this.productRemaindLimit = response.data.creditLimit
          this.productMinLimit = response.data.productMinLimit
          this.lendingAmountStep = response.data.lendingAmountStep
            ? response.data.lendingAmountStep
            : 500
          this.productMaxLimit = response.data.userMaxLimit
          // 额度默认取后端返回
          this.form.applyAmt = this.form.applyAmt || response.data.productDefaultAmt
          // 产品列表
          this.productSubList = response.data.productSubList
        }
        // 默认借款用途
        const allLoanPurposeKeys = this.dictionary.loanPurpose.map(item => item.key)
        if (this.dictionary.defaultLoanPurpose && allLoanPurposeKeys.includes(this.dictionary.defaultLoanPurpose)) {
          this.form.purpose = this.dictionary.defaultLoanPurpose
        }
      }
    },
    // 通过金额查询子产品 - 分期数据来源
    async getAmountProduct (applyAmount) {
      const params = {
        loanPlatform: 'TMD',
        applyAmount: applyAmount
      }
      if (this.activeIndex === 0) {
        params.riskTagProcess = 'UP_CARD'
      }
      const response = await this.amtProductX(params)
      if (response.success) {
        let terms = response.data
        this.amtProductList = terms
        if (terms && terms.length > 0) {
          this.form.applyTerm = terms[terms.length - 1]
        }
      } else {
        this.amtProductList = []
      }
    },
    // 当前是否可借款
    async canLoan () {
      const params = {
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt || '',
        totalTermNo: this.form.applyTerm || ''
      }
      if (this.activeIndex === 0) {
        params.riskTagProcess = 'UP_CARD'
      }
      const response = await this.canLoanX(params)
      if (response.success) {
        const { code, canLoanApply, message } = response.data
        this.canLoanCode = code
        this.canLoanApply = canLoanApply
        this.canotLoanReason = message

        if (code === 'F_000054') {
          this.$router.replace({
            path: '/withdraw/poor-credit',
            query: {
              status: 'time',
              count: message
            }
          })
        }
      }
    },
    async getFundRoute () {
      const params = {
        routeType: 'LOAN',
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt,
        totatlTermNo: this.form.applyTerm,
        productCode: 'TMDP'
      }
      if (this.activeIndex === 0) {
        params.riskTagProcess = 'UP_CARD'
      }
      const response = await this.getFundRouteX(params)
     
      if (response.success) {
        if (!response.data || response.data.length === 0) {
          if (this.activeIndex === 0) {
            this.noRouteDialog = true
          } else {
            this.$message('今日额度已抢完，明天再来吧')
          }
        } else {
          this.$storage.set('fundRoute', response.data[0])
          this.fundCode = response.data[0].fundCode
        }
      } else {
        this.$storage.remove('fundRoute')
        this.$message(response.msg)
      }
    },
    async next () {
      const canLoanParams = {
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt || '',
        totalTermNo: this.form.applyTerm || ''
      }
      if (this.activeIndex === 0) {
        canLoanParams.riskTagProcess = 'UP_CARD'
      }
      // 不能借款时，拦截
      const canLoanRes = await this.canLoanX(canLoanParams)
      if (!canLoanRes.success || !canLoanRes.data.canLoanApply) {
        return
      }
      this.$indicator()
      await this.getFundRoute()

      if (!this.fundCode) {
        this.$indicator.close()
        return
      }

      const params = {
        loanTerm: this.form.applyTerm,
        withdrawAmt: this.form.applyAmt,
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        repayMethod: 'AI',
        productCd: 'TMDP'
      }
      if (this.activeIndex === 0) {
        params.riskTagProcess = 'UP_CARD'
      }
      const response = await this.getLoanTrialX(params)
      this.$indicator.close()
      if (response.success) {
        this.$storage.set('repayTrail', response.data)
        const res = await this.judgeMissingX()
        this.$storage.set(WITHDRAW_PASSCARD_FORM_KEY, this.form)
        this.setWithdrawForm(this.form)
        if (res.success && res.data.missing) {
          let value = getKey('channel') !== 'API-XHQB' ? 'F' : 'T'
          this.$router.push({
            path: '/authentication/smallFlowerBase',
            query: { notify: value, fundCode: this.fundCode, riskTagProcess: 'UP_CARD' }
          })
        } else {
          const query = { fundCode: this.fundCode, couponSerialNos: this.$route.query.couponSerialNos }
          if (this.activeIndex === 0) {
            query.riskTagProcess = 'UP_CARD'
          }
          removeKey('withdrawButtonHasBeenClicked')
          this.$router.push({
            path: '/withdraw/preview',
            query
          })
        }
      }
    },
    
    detention () {
      if (this.canLoanApply) {
        this.$refs.backPopup.init()
      } else {
        this.backHome()
      }
    },
    
    beforeSelectTerm () {
      if (this.termList.length === 0) {
        // this.$message('当前没有可匹配的期数')
        return Promise.resolve(false)
      }
      return Promise.resolve(true)
    }


  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #FAFAFA;
  .tips-dialog{
    border-radius: 30px;
    .tips-content {
        padding: 20px 50px 70px;
        .header {
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 59px;
        }
        .body {
            margin-top: 26px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            .highlight {
                color: #ff3446;
            }
        }
        .footer {
            display: block;
            width: 460px;
            height: 80px;
            line-height: 80px;
            margin: 90px auto 0;
        }
        .cancel {
            margin-top: 40px;
            font-size: 28px;
            color: rgba(142, 178, 216, 1);
            line-height: 40px;
            text-decoration: underline;
            text-align: center;
        }
    }
  }
  .activity-dialog {
    border-radius: 30px;
    .default-content {
      background: linear-gradient(90deg, #fef6e4 0%, #fcd5ac 100%) !important;
      .activity-template-content {
        width: 620px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;

        .title {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333;
          line-height: 45px;
          text-align: center;
        }
        .content {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333;
          line-height: 37px;
          padding: 20px 0;
        }
        .btn {
          width: 318px;
          height: 80px;
          line-height: 80px;
          background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
          border-radius: 40px;
          margin-top: 30px;
        }
        .giveup-btn {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999;
          line-height: 40px;
          text-align: center;
          margin-top: 30px;
          text-decoration: underline;
        }
        .xy-tips {
          color: #763e12;
          text-align: center;
          margin-top: 30px;
          .active {
            color: #763e12;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .use-tips {
    margin-top: 20px;
    img {
      width: 100%;
    }
  }
  .swiper-container {
    height: 100%;
    padding: 30px 0;

    & .item:nth-of-type(1) {
      padding-left: 30px;
    }

    & .item:nth-of-type(2) {
      padding-right: 30px;
    }

    .van-swipe-item {
      padding: 10px;
      height: 380px;
      .card-item {
        height: 310px;
        border-radius: 30px;
        overflow: hidden;
        padding: 30px;
        position: relative;
      }
      &:before {
        content: "";
        position: absolute;
        width:80%;
        height:270px;
        left:10%;
        top:40px;
        box-shadow: 0 10px 30px #3C4361;
        border-radius: 30px;
      }
      &.item2 {
        &:before {
          box-shadow: 0 10px 30px rgb(235, 129, 129);
        }
      }
      .card-item1 {
        background: linear-gradient(180deg, #3C4361 0%, #1C2032 100%);
        position: relative;
        &:after {
          position: absolute;
          right:0;
          top:0;
          content: "放款通过率98%";
          width: 206px;
          height: 50px;
          background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #763E12;
          text-align: center;
          line-height: 50px;
          border-bottom-left-radius: 30px;
        }
        .title {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFDDB8;
          line-height: 45px;
          display: flex;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            margin-top: 5px;

          }
        }

        .info {
          display: flex;
          flex-direction: column;
          padding-top: 40px;

          span {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFDDB8;
          }

          b {
            font-size: 80px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: #FFDDB8;
          }

          p {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #978982;
          }
        }
      }

      .card-item2 {
        background: linear-gradient(180deg, #FE9B4C 0%, #FF3333 100%);

        .title {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fff;
          line-height: 45px;
          display: flex;
          align-items: center;
        }
        .max-withdraw{
          width: 190px;
          height: 60px;
          background: #FFFFFF;
          border-radius: 40px;
          text-align: center;
          line-height: 60px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FF4633;
          margin-top: -10px;
        }
        .money-range {
          display: flex;
          justify-content: space-between;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 33px;
          padding: 10px 0;
        }

        .info {
          display: flex;
          position: relative;
          margin-top: 30px;
          align-items: center;
          &:after {
            content: "";
            height: 1px;
            width: 100%;
            background: #fff;
            left: 0;
            position: absolute;
            bottom: 0;
          }
          .amount-container {
            display: flex;
            flex-direction: column;
            color: #fff;
            flex:1;

            span {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 33px;
            }

            .money {
              font-size: 80px;
              font-family: DIN-Medium, DIN;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 97px;
            }
          }
        }
      }
    }
  }

  .swiper-card {
    width: 100%;
    height: 380px;
    position: relative;
    .temporary-limit {
      position: absolute;
      z-index: 9;
      right: 0;
      top:5px;
      right: 30px;
    }
  }

  .pay-loading {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    display: flex;
    background: #fff;
    justify-content: center;

    .back {
      float: right;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      text-decoration: underline;
      text-align: right;
      padding: 30px;
      z-index: 9;
      position: absolute;
      right: 0;
    }

    p {
      font-size: 34px;
      text-align: center;
      margin-top: 30px;
      font-weight: bold;
    }
  }

  .card-panel {
    background-color: #fff;
    margin-top: 20px;
  }

  .form {
    padding: 0 30px;

    .form-item {
      height: 110px;
      line-height: 110px;
      margin-top: 0;

      .nd-choose {
        label {
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }

        input {
          font-size: 30px;
        }

        textarea {
          font-size: 30px;
        }
      }
    }
  }

  .tips {
    padding: 11px 40px;
    background: #FFF9F1;
    font-size: 24px;
    color: #FF8864;
    line-height: 33px;
  }

  .bottom {
    width: 750px;
    height: 230px;
    background: #fff;
    box-shadow: 0 0 8px 0 #000 4%;
    position: fixed;
    bottom: 0;

    .read-protocol {
      width: 100%;
      text-align: center;
      margin-top: 25px;

      span {
        display: block;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }
    }

    .confirm {
      margin: 30px auto 0;
      width: 650px;
      height: 94px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 47px;
    }
  }

  .detention-dialog {
    .detention-title {
      margin: 0 20px;
      text-align: center;
      font-size: 36px;
      line-height: 50px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      padding-bottom: 34px;
      border-bottom: 1px solid #EEEEEE;

      span {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 70, 51, 1);
        line-height: 50px;
      }
    }

    .giveup {
      li {
        height: 110px;
        line-height: 110px;
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: @fc3;
        border-bottom: 1px solid #EEEEEE;
      }
    }

    .continue {
      border: 0px solid transparent;
      height: 160px;
      line-height: 160px;
      text-align: center;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: @theme;
      width: 100%;
      -webkit-appearance: none;
      outline: none;
      background-color: #FFFFFF;
    }
  }
}
</style>
